import React, { useState } from 'react';
import { useWizard } from '../../../../../components/wizard/WizardContext';
import StudentDetails from '../selectRefundItems/StudentDetails';
import { initiateMultiTypeRefund, studentDetailsLabelFieldMapping } from '../utils';
import RefundDetailsForm from '../selectRefundItems/RefundDetailsForm';
import RefundItems from '../selectRefundItems/refundItems';
import RefundAccountsCard from '../selectRefundAccounts/RefundAccountsCard';
import UploadDocuments from '../selectRefundItems/UploadDocuments';
import Footer from '../../../../studentTransfer/components/Footer';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import RectRefundInitSuccessDialog from '../../rectificationRefund/verifyDetails/RectRefundInitSuccessDialog';

const VerifyMultiTypeRefundDetails = () => {

    const [loading, setLoading] = useState(false);
    const [successDialogInfo, setSuccessDialogInfo] = useState({});

    const { values, dropdowns, params } = useWizard();

    const forRefundEdit = params?.mode === 'edit';

    const { multiTypeRefundStep2Data, multiTypeRefundStep3Data, selectedStudent, multiTypeRefundUtils, refundType } = values;

    const {
        additionalStudentDetails,
        refundDetailsForm,
        payableRefundInfo,
        isFullRefund,
        isConcessionRefund,
        selectedRefundItems,
        totalAmountToRefund,
        isDLPCase,
        totalPayableToVendor
    } = multiTypeRefundStep2Data;

    const studentDetails = {
        ...selectedStudent,
        ...additionalStudentDetails
    }

    const { studentLoanDetails = {}, coursePricingDetails = {} } = studentDetails;
    const { isLoanCase, doId } = studentLoanDetails;

    const { primaryStudentAccount, loanVendorAccount } = multiTypeRefundStep3Data;

    const refundAccounts = [
        primaryStudentAccount,
        ...(totalPayableToVendor > 0 ? [loanVendorAccount] : [])
    ]

    const issueRefundClickHandler = async () => {
        try {
            setLoading(true);
            const resp = await initiateMultiTypeRefund({ studentDetails, multiTypeRefundStep2Data, primaryStudentAccount, loanVendorAccount, isLoanCase, refundType, doId, forRefundEdit });
            debugger
            if (resp?.code === 200) {
                const {createdOn, createdBy,updatedBy,refundNumber, response = []} = resp?.data ?? {};
                const refundNumbersArr = selectedRefundItems?.map(item => response?.find(el => el?.refundType === item)?.refundNumber);
                const refundNo = refundNumber||refundNumbersArr?.join(",");
                setSuccessDialogInfo({ isOpen: true, createdOn, createdBy:updatedBy||createdBy, refundNumber:refundNo, multipleRefundsRaised : refundNumbersArr?.length > 1 });
            }


        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }




    return (

        <div className='d-flex flex-column m-2' style={{ gap: '1.5rem' }}>

            {loading && <ALoader position={"fixed"} />}

            <StudentDetails
                studentDetails={studentDetails}
                labelFieldMappings={studentDetailsLabelFieldMapping(studentDetails, dropdowns?.data)}
            />

            <RefundDetailsForm
                form={refundDetailsForm}
                studentDetails={studentDetails}
                viewOnly={true}
                studentLoanDetails={studentLoanDetails}
                coursePricingDetails={coursePricingDetails}
                isDLPCase={isDLPCase}
            />

            <RefundItems
                refundItems={selectedRefundItems}
                payableRefundInfo={payableRefundInfo}
                refundDetailsForm={refundDetailsForm}
                isFullRefund={isFullRefund}
                selectedRefundItems={selectedRefundItems}
                isConcessionRefund={isConcessionRefund}
                isLoanCase={isLoanCase}
                viewOnly={true}
                totalAmountToRefund={totalAmountToRefund}
                isDLPCase={isDLPCase}
            />

            <RefundAccountsCard
                multiTypeRefundUtils={multiTypeRefundUtils}
                title={"Refund Accounts"}
                accountDetails={refundAccounts}
                viewOnly={true}
                showBeneficiaryTypeChip={true}
            />

            <Footer>
                <div>Check student & account details</div>
                <AButton
                    // disabled={!primaryStudentAccount}
                    onClick={issueRefundClickHandler}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                >
                    Verify and issue refund
                </AButton>
            </Footer>

            <RectRefundInitSuccessDialog
                dialogInfo={successDialogInfo}
            />

        </div>

    );
}

export default VerifyMultiTypeRefundDetails;